import React, { useEffect } from 'react';

const BillToPartyInput = (props: any) => {
	const {
		billToCustomers,
		onSearchBillToParty,
		billToPartySearchResponse,
		closeOthersSearch,
		onBillToPartyDropDownChange,
		onInputChange,
		searchHasError,
		searchErrorMessage,
		onInputKeyUp,
		onSetErrorMessage,
		isDisabled,
		athenaBillToParty,
		updateAthenaBillToParty
	} = props;

	useEffect(() => {
		if (athenaBillToParty) {
			if (athenaBillToParty.beCode && athenaBillToParty.factCode && athenaBillToParty.name) {
				updateAthenaBillToParty();
			}
		}
	}, []);

	const handleOnChange = (e: any) => {
		const { value } = e.target;
		onInputChange(value);
	};

	const handleOnBlur = (e: any) => {
		const { value } = e.target;
		if (value.length > 4) {
			const customerExists = billToCustomers.find((customer: any) => customer.value === value);
			if (customerExists) {
				onBillToPartyDropDownChange(customerExists.value);
			} else {
				onSearchBillToParty(value);
			}
		} else {
			onSetErrorMessage('Please insert at least 5 characters');
		}
	};

	const handleCloseOthersSearch = () => {
		closeOthersSearch();
	};

	const handleOnKeyUp = (e: any) => {
		onInputKeyUp(e);
	};

	return (
		<React.Fragment>
			<div className="search-container">
				<label htmlFor="search-input" className="search-label">
					Please specify Country code + BECode
				</label>
				<div className="search-input-section">
					<input
						type="text"
						id="search-input"
						className={`search-input ${searchHasError ? 'has-error' : ''}`}
						autoComplete="off"
						placeholder="Please insert..."
						onChange={handleOnChange}
						onKeyUp={handleOnKeyUp}
						onBlur={handleOnBlur}
						value={billToPartySearchResponse}
						disabled={isDisabled}
					/>
					{!isDisabled &&
						<button
							title="Close"
							type="button"
							className="search-close"
							onClick={handleCloseOthersSearch}
						>
							<i className="fa fa-times" />
						</button>
					}
				</div>
				{searchHasError && (
					<div className="search-error">
						<span>{searchErrorMessage}</span>
					</div>
				)}
			</div>
		</React.Fragment>
	);
};

export default BillToPartyInput;